<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>
<div class="card-body-tab">
    <div class="col-12 px-2">
        <div class="cards-body">
            <div class="tableSpacing">
                <div class="box-body table-responsive-sm table-responsive-md table-responsive-lg" style="overflow-x: auto">
                    <table id="example1" class="table card-layout table-striped table">
                        <thead>
                            <tr id="main_row_headingId">
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <div class="header-color cursorPointer header_title">Trip ID</div>
                                        <div
                                            class="header-color cursorPointer header_title"
                                            (click)="
                                                sortBy = 'requestedBy';
                                                sortOrder = !sortOrder;
                                                invoiceStatusReportSorting.requestedBy = !invoiceStatusReportSorting.requestedBy
                                            "
                                        >
                                            Requested By
                                            <ds-icon
                                                *ngIf="invoiceStatusReportSorting.requestedBy"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!invoiceStatusReportSorting.requestedBy"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer header_title"
                                            (click)="
                                                sortBy = 'requestedOn';
                                                sortOrder = !sortOrder;
                                                invoiceStatusReportSorting.requestedOn = !invoiceStatusReportSorting.requestedOn
                                            "
                                        >
                                            Requested On
                                            <ds-icon
                                                *ngIf="invoiceStatusReportSorting.requestedOn"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!invoiceStatusReportSorting.requestedOn"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer header_title"
                                            (click)="
                                                sortBy = 'invoiceStatus';
                                                sortOrder = !sortOrder;
                                                invoiceStatusReportSorting.invoiceStatus = !invoiceStatusReportSorting.invoiceStatus
                                            "
                                        >
                                            Invoice Status
                                            <ds-icon
                                                *ngIf="invoiceStatusReportSorting.invoiceStatus"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!invoiceStatusReportSorting.invoiceStatus"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div class="header-color cursorPointer header_title">Failure Reason</div>
                                    </div>
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr
                                *ngFor="
                                    let record of invoiceStatusReportData?.data
                                        | orderBy: sortBy : sortOrder
                                        | filter: searchText
                                        | paginate
                                            : {
                                                  id: 'invoiceStatusPagination',
                                                  itemsPerPage: itemsPerPage,
                                                  currentPage: currentPage,
                                                  totalItems: invoiceStatusReportData?.totalRecords,
                                              }
                                "
                            >
                                <td>
                                    <div id="main_row_id" class="row_container">
                                        <div class="title_container">
                                            <div class="row_title">Trip ID</div>
                                            <div *ngFor="let tripData of record.tripDetails" class="row_detail cursorPointer">
                                                <a href="{{ itineraryPageRedirectUrl }}/{{ tripData.serviceRequestId }}/Report">
                                                    {{ tripData.tripId }}
                                                </a>
                                            </div>
                                        </div>

                                        <div class="title_container">
                                            <div class="row_title">Requested By</div>
                                            <div class="row_detail">
                                                {{ record.requestedBy }}
                                            </div>
                                        </div>

                                        <div class="title_container">
                                            <div class="row_title">Requested On</div>
                                            <div class="row_detail cursorPointer">
                                                {{ record.requestedOn | localDate: timeZone }}
                                            </div>
                                        </div>

                                        <div class="title_container">
                                            <div class="row_title">Invoice Status</div>
                                            <div class="row_detail">
                                                {{ record.invoiceStatus ? record.invoiceStatus : 'N/A' }}
                                            </div>
                                        </div>

                                        <div class="title_container">
                                            <div class="row_title">Failure Reason</div>
                                            <div class="row_detail">
                                                {{ record.invoiceFailureReason ? record.invoiceFailureReason : '' }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>

                        <tbody></tbody>
                    </table>
                </div>
                <div *ngIf="invoiceStatusReportData?.totalRecords == 0" class="mt-2" style="color: #a82b41">
                    <b>No Records Found</b>
                </div>
                <div *ngIf="invoiceStatusReportData?.totalRecords > 0" class="col-md-12 p-0 paginationAlingment" style="margin-top: 10px">
                    <div class="col-md-6 p-0">
                        {{ paginationText }}
                    </div>
                    <div class="col-md-6 pagination text-end mt-1">
                        <pagination-controls
                            id="invoiceStatusPagination"
                            [maxSize]="6"
                            [nextLabel]="''"
                            [previousLabel]="''"
                            [responsive]="responsive"
                            (pageChange)="currentPage = $event; updatePaginationText(true)"
                        >
                        </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
